import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MobileLayout } from './components/layout/MobileLayout';
import { AuthLayout } from './components/layout/AuthLayout';
// Dashboard Pages
import { Home } from './pages/Home';
import { Profile } from './pages/Profile';
import { Marketplace } from './pages/Marketplace';
import { Training } from './pages/Training';
import { Messages } from './pages/Messages';
// Auth & Onboarding Pages
import { Splash } from './pages/auth/Splash';
import { Welcome } from './pages/auth/Welcome';
import { SelectUserType } from './pages/auth/SelectUserType';
import { Login } from './pages/auth/Login';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { Otp } from './pages/auth/Otp';
import { CreatePassword } from './pages/auth/CreatePassword';
import { Terms } from './pages/auth/Terms';
import { BeneficiaryOnboarding } from './pages/onboarding/BeneficiaryOnboarding';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Auth & Onboarding Flow (No Bottom Nav) */}
        <Route element={<AuthLayout data-id="element-3" />} data-id="element-2">
          <Route path="/splash" element={<Splash data-id="element-5" />} data-id="element-4" />
          <Route path="/welcome" element={<Welcome data-id="element-7" />} data-id="element-6" />
          <Route path="/select-user-type" element={<SelectUserType data-id="element-9" />} data-id="element-8" />
          <Route path="/login" element={<Login data-id="element-11" />} data-id="element-10" />
          <Route path="/forgot-password" element={<ForgotPassword data-id="element-13" />} data-id="element-12" />
          <Route path="/otp" element={<Otp data-id="element-15" />} data-id="element-14" />
          <Route path="/create-password" element={<CreatePassword data-id="element-17" />} data-id="element-16" />
          <Route path="/terms" element={<Terms data-id="element-19" />} data-id="element-18" />
          <Route path="/onboarding" element={<BeneficiaryOnboarding data-id="element-21" />} data-id="element-20" />
        </Route>

        {/* Main Dashboard Flow (With Bottom Nav) */}
        <Route path="/app" element={<MobileLayout data-id="element-23" />} data-id="element-22">
          <Route index element={<Home data-id="element-25" />} data-id="element-24" />
          <Route path="marketplace" element={<Marketplace data-id="element-27" />} data-id="element-26" />
          <Route path="training" element={<Training data-id="element-29" />} data-id="element-28" />
          <Route path="messages" element={<Messages data-id="element-31" />} data-id="element-30" />
          <Route path="profile" element={<Profile data-id="element-33" />} data-id="element-32" />
        </Route>

        {/* App launches into the auth flow */}
        <Route path="/" element={<Navigate to="/splash" replace data-id="element-35" />} data-id="element-34" />
        <Route path="*" element={<Navigate to="/splash" replace data-id="element-37" />} data-id="element-36" />
      </Routes>
    </BrowserRouter>;
}